export default __webpack_public_path__ + "static/media/WallNotification_Aruba-Picture.2d3e736b.png";